import React from 'react';

import spinnerImg from '../images/dotdotdot.gif'
import './LoadingGauge.css'

export default function LoadingGauge(props) {
    return (
        <div className='gauge-loading'>
            <img src={spinnerImg} width="50" alt="Loading..." />
        </div>
    )
}
